import React, { Fragment } from 'react'

function formatMAD(value) {
    return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(value)
}

function MonthlyBudgetChart({ data, monthlyAllowed }) {
    const max = Math.max(monthlyAllowed, ...data.map(d => d.value), 1)

  return (
    <Fragment>
        <div className='monthlyBudgetChart'>
            {data.map((d) => {
                const height = (d.value / max) * 100
                const isOver = d.value > monthlyAllowed

                return (
                    <div className='barColumn' key={d.month}>
                        <span className='barValue'>{formatMAD(d.value)}</span>
                        <div className='barTrack'>
                            <div className={`bar${isOver ? ' over' : ''}`} style={{ height: `${height}%` }}></div>
                        </div>
                        <span className='barLabel'>{d.month}</span>
                    </div>
                )
            })}
        </div>
        <div className='chartLegend'>
            <span><i className='dot dot-normal'></i>Sous la moyenne mensuelle allouée</span>
            <span><i className='dot dot-over'></i>Au-dessus de la moyenne mensuelle allouée</span>
        </div>
    </Fragment>
  )
}

export default MonthlyBudgetChart
